import { render, staticRenderFns } from "./TableConfigurationProviderTopRight.vue?vue&type=template&id=3ef60097&scoped=true&"
import script from "./TableConfigurationProviderTopRight.vue?vue&type=script&lang=js&"
export * from "./TableConfigurationProviderTopRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef60097",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
